import {ButtonSelect} from '@components/common/controls/button-select'
import {DropdownList} from '@components/common/dropdown-list/dropdown-list'
import * as React from 'react'
import {Lang} from 'yougile-lang'
import {
  getAllFields,
  ReportDataField,
  ReportFieldKey,
  ReportSort
} from 'yougile-model'
import {ArrUtil, Util} from 'yougile-util'
import {Sync} from '../../../client/sync'
import {getAllStickers} from '../../../extensions/sticker/sticker-data-extractor'
import {Option} from '../../common/select/select'
import {Remove, Separator} from './common'

interface Props {
  sort: ReportSort[]
  update: (newSort: ReportSort[]) => void
}

interface InnerProps {
  allFields: ReportDataField[]
}

const SortBase = (props: Props & InnerProps) => {
  const {allFields, sort = [], update} = props
  const bem = Util.bemFrom('stats-reports-sort')
  const options: Option[] = allFields.map(f => ({
    label: f(Lang.msg).getName(),
    value: f(Lang.msg).key
  }))
  const ascOptions: Option[] = [
    {value: 'asc', label: Lang.msg.asc},
    {value: 'desc', label: Lang.msg.desc}
  ]

  const add = (key: ReportFieldKey) => update([...sort, {key, asc: false}])
  const remove = (ix: number) => () => update(ArrUtil.deletedAtIndex(sort, ix))
  const selectKey = (ix: number) => (key: ReportFieldKey) =>
    update(ArrUtil.changedAtIndex(sort, {key, asc: false}, ix))
  const selectAsc = (ix: number) => (asc: string) =>
    update(
      ArrUtil.changedAtIndex(sort, {key: sort[ix].key, asc: asc === 'asc'}, ix)
    )

  return (
    <div className={bem()}>
      {sort.map((s, ix) => {
        return (
          <div className={bem('sort')} key={s.key}>
            <div
              className="text-third-old w-20 h-24 flex items-center text-12"
              style={{marginLeft: 22}}
            >
              {ix + 1}.
            </div>
            <DropdownList
              className="w-184"
              options={options}
              value={s.key}
              onChange={selectKey(ix)}
            />
            <Separator />
            <DropdownList
              className="w-160"
              options={ascOptions}
              value={s.asc ? 'asc' : 'desc'}
              onChange={selectAsc(ix)}
            />
            <Remove onClick={remove(ix)} />
          </div>
        )
      })}
      <ButtonSelect
        className={bem('add')}
        buttonLabel={Lang.msg.statsAddSort}
        dropdownOffset={30}
        options={options}
        onSelect={add}
        placeholder={Lang.msg.statsChooseSort}
      />
    </div>
  )
}

export const Sort = (props: Props) => {
  const box = Sync.getCurrentSandbox()
  const allStickers = getAllStickers(box, true)
  const allFields = getAllFields(allStickers)
  return <SortBase {...props} allFields={allFields} />
}
